<template>

<body>
<!-- preloader -->
<Loader> </Loader>
<!-- preloader -->

    <div class="frame">
  <div class="site-wrapper overflow-hidden">

     <!-- Header Section -->
    <Front-Header> </Front-Header>

 

    <!-- Main Start-->
    <section class="hero_section height-half text-center">
    <img :src="pages.image" style="position: absolute;" :alt="pages.title">       
          <div class="container">
              <h1 data-aos="fade-right" data-aos-duration="1200" class="aos-init aos-animate">{{ pages.title }}</h1>
              <p data-aos="fade-left" data-aos-duration="1200" data-aos-delay="200" class="aos-init aos-animate">{{ pages.short_description }}</p>
          </div>
    </section>

    <!--Contact-us start-->
    <div id="contactUs">
        <section class="contact_wrapper">
        <div class="container">
            <div class="contact_info">
    <h3 class="title">
      {{pages.title}}
    </h3>

    <ul class="icons_wrapp pl-0">
      <li class="d-flex">
        <div class="icon">
          <i class="fas fa-map-marker-alt mr-2"></i>
        </div>
        <div class="text">
           {{address.mapLocation}}
        </div>
      </li>
      <li>
        <div class="icon">
          <i class="fas fa-envelope mr-2"></i>
        </div>
        <div class="text">
        {{ address.email }}
        </div>
      </li>
      <li>
        <div class="icon">
          <i class="fa fa-phone-alt mr-2"></i>
        </div>
        <div class="text">
        {{ address.phoneNumber }}
        </div>
      </li>
    </ul>

    <ul class="soci_wrap pl-0">
      <li>
        <a v-bind:href="''+sociallinks.facebook+''">
          <i class="fab fa-facebook-f"></i>
        </a>
      </li>
      <li>
        <a v-bind:href="''+sociallinks.twitter+''">
          <i class="fab fa-twitter"></i>
        </a>
      </li>
      <li>
        <a v-bind:href="''+sociallinks.instagram+''">
          <i class="fab fa-instagram"></i>
        </a>
      </li>
     
      <!--<li>
        <a v-bind:href="''+sociallinks.facebook+''">
          <i class="fab fa-youtube"></i>
        </a>
      </li> -->
    </ul>
  </div>
  
  <div class="contact_msg">
    <h3 class="title">
      Send a Message
    </h3>

    <form class="form-horizontal form-material" v-on:submit.prevent="submit">
    <div class="form_fild">
      <div class="input_group w_50">
        <input placeholder="First Name" type="text" class="input" v-model.trim="$v.first_name.$model" :class="{'is-invalid': validationStatus($v.first_name)}">
        <div v-if="!$v.first_name.required" class="invalid-feedback">The first name field is required.</div>
        
      </div>

      <div class="input_group w_50">
        <input placeholder="Last Name" type="text" class="input" v-model.trim="$v.last_name.$model" :class="{'is-invalid': validationStatus($v.last_name)}">
        <div v-if="!$v.last_name.required" class="invalid-feedback">The last name field is required.</div>
      </div>

      <div class="input_group w_50">
        <input placeholder="Emal Address" type="text" class="input" v-model.trim="$v.email.$model" :class="{'is-invalid': validationStatus($v.email)}">
        <div v-if="!$v.email.required" class="invalid-feedback">The email field is required.</div>
        <div v-if="!$v.email.email" class="invalid-feedback">Email is invalid.</div>
      </div>

      <div class="input_group w_50">
        <input placeholder="Phone Number" type="tel" class="input" v-model.trim="$v.phone_no.$model" :class="{'is-invalid': validationStatus($v.phone_no)}">
        <div v-if="!$v.phone_no.required" class="invalid-feedback">The phone number field is required.</div>
      </div>
 <div class="input_group w-100">
 <select  @change="selectCategory($event)" name="queriese" id="sel">
		<option value="">Select queriese</option>
		<option value="6zGYBwseupcZMmLnBXxl">Billing and payment support</option>
		<option value="LLDi2b6dpBfdglXm71dj">General queries and help</option>
		<option value="UjSO400vO0D8Pgu3qkNT">Press and Meadia inquiries</option>
		<option value="z0FnmzSpFP4sEopHNz4w">Business  inquiries</option>
  </select>
      </div>
      <div class="input_group w-100">
        <textarea placeholder="Write your message here..." class="input input_textarea" rows="6" v-model.trim="$v.message.$model" :class="{'is-invalid': validationStatus($v.message)}"></textarea>
        <div v-if="!$v.message.required" class="invalid-feedback">The message field is required.</div>      </div>

      <div class="input_group">
        <input type="submit" class="btn" value="Send">
      </div>

    </div>
    </form>

  </div>

        </div>
    </section>
    </div>
    <!-- Main End-->
    
    <!-- Footer Section -->
    <Front-Footer> </Front-Footer>
  
  </div>
  </div>
 
  </body>
</template>
<script>
import Header from './Front-Header';
import Footer from './Front-Footer';
import Loader from './Loader';
import VueMeta from 'vue-meta';
import Vue from 'vue';
Vue.use(VueMeta)
import { db } from '../main'
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'

  export default {
    components:{
      'Front-Header':Header,
      'Front-Footer':Footer,
      'Loader':Loader,
  },
  data(){
    return{
      pages:{},
      address:{},
      users:{},
      sociallinks:{},
	addresss: '',
	emails: '',
	phones: '',
      subject: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_no: '',
      emailm: '',
	emailname: '',
      message: '',
       meta_title:'',
      meta_description:'',
    }
  },
  metaInfo() {
    //alert();
       return { 
            title:this.meta_title,
            meta: [
                { name: 'description', content: this.meta_description},
            ]
      }
    },
  validations: {
      first_name: {required},
      last_name: {required},
      email: { required, email },
      phone_no: {required},
      message: {required},
  },

  created: function()
  {
      this.fetchPages();
      this.getUser();
  },

  methods: {

    validationStatus: function(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
   
    selectCategory(event) {
     this.subject = event.target.value;
    },
	
    submit: function() {

      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
        var  date = new Date().toLocaleString()
		
  db.collection("email_management")
        .get()  
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
               console.log(doc.data());
               console.log("doc.data()");
		if(doc.id == this.subject){
 this.emailm = doc.data().email;
   this.emailname = doc.data().Name;	 }
          
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
		
		
      //var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);  
           db.collection("contact_us")
            .add({ 
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                subject: this.emailname,
                phone_no:this.phone_no,
                message: this.message,
                created: date,
                modified: date,
            })
            .then(() => { 		 this.$router.push('/thankyou/?id='+this.subject);
			console.log("Added Successfully!");
			this.$toasted.success('Success, Thank you for contact!', {	   icon : 'check',
				//icon : 'error_outline'
			})
                
				var axios = require('axios');
				var FormData = require('form-data');
				var data = new FormData();
				data.append(' first_name', this.first_name);
				data.append('last_name',this.last_name);
				data.append('email', this.email);
				data.append('emailm', this.emailm);
				data.append('phone_no', this.phone_no);
				data.append('subject', this.emailname);
				data.append('message', this.message);

				var config = {		  method: 'post',	  url: 'https://introsbs.com/api/conatct_us',		   headers: {'Content-Type': 'multipart/form-data' },	  data : data
				};

				axios(config)
				.then(function (response) {	  console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {	  console.log(error);
				});

			
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
     

      // POST request using axios with set headers
      const data = {
      "email": "admin@gmail.com",
      "password": "admin@gmail.com",
      };
      axios.post("http://159.65.231.72/api/contacts_user", data)
      .then((response)=>{
        console.warn(response);
        this.$toasted.success('Success, Sent Successfully!', {
          icon : 'check',
           //icon : 'error_outline'
        })

      });
    },


    getUser()
    {
      db.collection("users").doc('6zoxAapxwxfb3Nu8H8tl')
      .get()
      .then((doc) => {
        // console.log('hhhh99');
          //console.log(doc.id, " => ", doc.data());
              this.users = doc.data();

      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
        
    },

    fetchPages()
    {
       window.scrollTo({ top: 0, behavior: 'smooth' });

      db.collection("pages").doc('W3sk77Lpp6GYAS2RXM6F')
      .get()
      .then((doc) => {
        console.log('hhhh88');
          console.log(doc.id, " => ", doc.data().description);
              this.pages = doc.data();
	console.log(doc.data().description.split("|"));
		this.addresss = doc.data().description.split("|")[0].split(">")[1];
		this.emails = doc.data().description.split("|")[1];
 this.phones = doc.data().description.split("|")[2].split("<")[0];
   this.meta_title = doc.data().meta_title;
               this.meta_description = doc.data().meta_description;
            
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });

      db.collection("sociallinks").doc('ot3idgvr902v0m6ynLEz')
      .get()
      .then((doc) => {
              //console.log('hhhh55');
              //console.log(doc.id, " => ", doc.data());
              this.sociallinks = doc.data();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
      
    db.collection("address").doc('UukY8WLJp0Bhn12B4mJB')
      .get()
      .then((doc) => {
              console.log('hhhh55');
              console.log(doc.id, " => ", doc.data());
              this.address = doc.data();
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });

    }
  }
}
    
</script>
<style>
#sel{
color:#c1bbb6;
}
.contact_wrapper form.form-horizontal.form-material {
    max-height: initial !important;
    overflow-y: visible;
}
.contact_wrapper form.form-horizontal.form-material .invalid-feedback {
    margin-top: 20px;
    position: absolute;
    height: 50px;
    z-index: 55;
    top: 24px;
    font-size: 12px;
}

#contactUs input.input:not(:focus) +  .placeholder{
  display:none !important;
}
  #contactUs select{
   color: #444;
  } 
</style>
